import DescriptionIcon from '@mui/icons-material/Description'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography
} from '@mui/material'
import { useMemo, useState } from 'react'

import { InspectionExpanded, PromptInfoTypeEnum } from '../../../sdk'

export const NotesButtonOfInspection = ({
  inspection
}: {
  inspection: InspectionExpanded
}) => {
  const [open, setOpen] = useState(false)
  const promptWithNotes = useMemo(() => {
    return inspection.prompts!.filter(
      (p) =>
        (p.info!.type === PromptInfoTypeEnum.OpenEnded && !!p.info!.answer) ||
        !!p.info!.technicianNotes
    )
  }, [inspection])
  if (promptWithNotes.length === 0) return <></>
  return (
    <>
      <IconButton
        onClick={(event) => {
          event?.stopPropagation()
          setOpen(true)
        }}
        color={'primary'}>
        <DescriptionIcon />
      </IconButton>
      <Dialog open={open} fullWidth maxWidth="sm">
        <DialogTitle>Notes</DialogTitle>
        <DialogContent>
          <Stack>
            {promptWithNotes.map((prompt, index) => {
              const { question, type, answer, technicianNotes } = prompt.info!
              return (
                <Stack key={index}>
                  <Typography variant="subtitle1">{question}</Typography>
                  <Typography>
                    {type === PromptInfoTypeEnum.OpenEnded
                      ? answer
                      : technicianNotes}
                  </Typography>
                </Stack>
              )
            })}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
